import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../_metronic/layout";
import { shallowEqual, useSelector } from "react-redux";
import { DashboardPage } from "./pages/DashboardPage";
import AdminsPage from "./modules/ContentManager/admins/AdminsPage";
import EditAdminsPage from "./modules/ContentManager/admins/EditAdminsPage";
import TextsPage from "./modules/ContentManager/texts/TextsPage";
import EditTextsPage from "./modules/ContentManager/texts/EditTextsPage";
import LanguagesPage from "./modules/ContentManager/languages/LanguagesPage";
import EditLanguagesPage from "./modules/ContentManager/languages/EditLanguagesPage";
import RelojesPage from "./modules/ContentManager/reloj/RelojesPage";
import RelojesPageScraping from "./modules/ContentManager/relojScraping/RelojesPage";
import ValorarRelojesPage from "./modules/ContentManager/relojScraping/ValorarRelojesPage";
import EditRelojPage from "./modules/ContentManager/reloj/EditRelojPage";
import ModelosPage from "./modules/ContentManager/modelo/ModelosPage";
import EditModeloPage from "./modules/ContentManager/modelo/EditModeloPage";
import MarcasPage from "./modules/ContentManager/marca/MarcasPage";
import EditMarcaPage from "./modules/ContentManager/marca/EditMarcaPage";
// Módulos ocultados temporalmente (se mantienen importados comentados por si se reactivan)
import LeatsPage from "./modules/ContentManager/leat/LeatsPage";
// import BannersSuperiorPage from "./modules/ContentManager/banner/BannersSuperiorPage";
// import EditBannerSuperiorPage from "./modules/ContentManager/banner/EditBannerSuperiorPage";
// import EditBannerInteriorPage from "./modules/ContentManager/banner/EditBannerInteriorPage";
// import BannersInteriorPage from "./modules/ContentManager/banner/BannersInteriorPage";
import BlogsPage from "./modules/ContentManager/blog/BlogsPage";
import EditBlogPage from "./modules/ContentManager/blog/EditBlogPage";
import TagsPage from "./modules/ContentManager/tag/TagsPage";
import EditTagPage from "./modules/ContentManager/tag/EditTagsPage";
import CategoriasPage from "./modules/ContentManager/categoria/CategoriasPage";
import EditCategoriaPage from "./modules/ContentManager/categoria/EditCategoriaPage";
import LeatVentasPage from "./modules/ContentManager/leatVenta/LeatsVentaPage";
import LogsTasacionPage from "./modules/ContentManager/logTasacion/LogsTasacionPage";
import BestsellersPage from "./modules/ContentManager/bestseller/BestsellersPage";
// import NotesPage from "./modules/ContentManager/note/NotesPage";
// import EditNotePage from "./modules/ContentManager/note/EditNotesPage";
import FAQsPage from "./modules/ContentManager/faq/FAQsPage";
import EditFAQsPage from "./modules/ContentManager/faq/EditFAQsPage";
import ReviewsPage from "./modules/ContentManager/review/ReviewsPage";
import EditReviewPage from "./modules/ContentManager/review/EditReviewPage";
import PedidosPage from "./modules/ContentManager/pedido/PedidosPage";
import EditConstantsPage from "./modules/ContentManager/constants/EditConstantsPage";
import CuponesPage from "./modules/ContentManager/cupon/CuponesPage";
import EditCuponPage from "./modules/ContentManager/cupon/EditCuponPage";
import CampanasPromocionalesPage from "./modules/ContentManager/brevo/CampanasPromocionalesPage";
import MultimediaPage from "./modules/ContentManager/multimedia/MultimediaPage";
import EditMultimediaPage from "./modules/ContentManager/multimedia/EditMultimediaPage";

export default function BasePage() {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const isAdmin = user && user?.role === "admin";

  // Si no es admin, redirigir al dashboard (que mostrará un mensaje de acceso denegado)
  if (!isAdmin) {
    return (
      <Switch>
        <Redirect from="*" to="/dashboard" />
      </Switch>
    );
  }

  return (
    <Switch>
      {/* Redirect from root URL to /dashboard. */}
      <Redirect exact from="/" to="/dashboard" />
      <ContentRoute path="/dashboard" component={DashboardPage} />

      {/* USERS */}
      {/* Administrators */}
      <ContentRoute from="/admins" component={AdminsPage} />
      <ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />

      {/* Banners (ocultados temporalmente) */}
      {/*
      <ContentRoute
        from="/banners-home-superior"
        component={BannersSuperiorPage}
      />
      <ContentRoute
        from="/edit-banners-home-superior/:id?"
        component={EditBannerSuperiorPage}
      />
      <ContentRoute
        from="/banners-home-interior"
        component={BannersInteriorPage}
      />
      <ContentRoute
        from="/edit-banners-home-interior/:id?"
        component={EditBannerInteriorPage}
      />
      */}

      {/* Marca */}
      <ContentRoute from="/marcas" component={isAdmin ? MarcasPage : DashboardPage} />
      <ContentRoute from="/edit-marca/:id?" component={isAdmin ? EditMarcaPage : DashboardPage} />
      {/* Modelo */}
      <ContentRoute from="/modelos" component={isAdmin ? ModelosPage : DashboardPage} />
      <ContentRoute from="/edit-modelo/:id?" component={isAdmin ? EditModeloPage : DashboardPage} />
      {/* Reloj */}
      <ContentRoute from="/relojes" component={isAdmin ? RelojesPage : DashboardPage} />
      <ContentRoute from="/edit-reloj/:id?" component={isAdmin ? EditRelojPage : DashboardPage} />
      <ContentRoute from="/bestsellers" component={isAdmin ? BestsellersPage : DashboardPage} />

      <ContentRoute from="/scraping-relojes" component={isAdmin ? RelojesPageScraping : DashboardPage} />
      <ContentRoute from="/tasar" component={isAdmin ? ValorarRelojesPage : DashboardPage} />

      <ContentRoute
        from="/leats"
        component={!isAdmin ? DashboardPage : LeatsPage}
      />
      <ContentRoute
        from="/leat-ventas"
        component={!isAdmin ? DashboardPage : LeatVentasPage}
      />
      <ContentRoute
        from="/logs-tasacion"
        component={!isAdmin ? DashboardPage : LogsTasacionPage}
      />

      {/* MISCELLANY */}
      {/* Languages */}
      <ContentRoute
        from="/languages"
        component={isAdmin ? LanguagesPage : DashboardPage}
      />
      <ContentRoute
        from="/edit-language/:id?"
        component={isAdmin ? EditLanguagesPage : DashboardPage}
      />
      {/* Texts */}
      <ContentRoute
        from="/texts"
        component={isAdmin ? TextsPage : DashboardPage}
      />
      <ContentRoute
        exact
        from="/edit-text"
        component={isAdmin ? EditTextsPage : DashboardPage}
      />
      <ContentRoute
        from="/edit-text/:id"
        component={isAdmin ? EditTextsPage : DashboardPage}
      />

      {/* Blogs, Tags, Categorías */}
      <ContentRoute
        from="/tags"
        component={!isAdmin ? DashboardPage : TagsPage}
      />
      <ContentRoute
        from="/edit-tag/:id?"
        component={!isAdmin ? DashboardPage : EditTagPage}
      />

      <ContentRoute
        from="/blogs"
        component={!isAdmin ? DashboardPage : BlogsPage}
      />
      <ContentRoute
        from="/edit-blog/:id?"
        component={!isAdmin ? DashboardPage : EditBlogPage}
      />

      <ContentRoute
        from="/categorias"
        component={!isAdmin ? DashboardPage : CategoriasPage}
      />
      <ContentRoute
        from="/edit-categoria/:id?"
        component={!isAdmin ? DashboardPage : EditCategoriaPage}
      />

      {/* FAQs */}
      <ContentRoute
        from="/faqs"
        component={isAdmin ? FAQsPage : DashboardPage}
      />
      <ContentRoute
        from="/edit-faq/:id?"
        component={isAdmin ? EditFAQsPage : DashboardPage}
      />

      {/* Reviews (TrustReviews / Home) */}
      <ContentRoute
        from="/reviews"
        component={isAdmin ? ReviewsPage : DashboardPage}
      />
      <ContentRoute
        from="/edit-review/:id?"
        component={isAdmin ? EditReviewPage : DashboardPage}
      />

      {/* Pedidos */}
      <ContentRoute
        from="/pedidos"
        component={isAdmin ? PedidosPage : DashboardPage}
      />

      {/* Constants */}
      <ContentRoute
        from="/constants"
        component={isAdmin ? EditConstantsPage : DashboardPage}
      />

      {/* Cupones */}
      <ContentRoute
        from="/cupones"
        component={isAdmin ? CuponesPage : DashboardPage}
      />
      <ContentRoute
        from="/edit-cupon/:id?"
        component={isAdmin ? EditCuponPage : DashboardPage}
      />

      {/* Campañas Promocionales (Brevo) */}
      <ContentRoute
        from="/campanas-promocionales"
        component={isAdmin ? CampanasPromocionalesPage : DashboardPage}
      />

      {/* Multimedia */}
      <ContentRoute
        from="/multimedia"
        component={isAdmin ? MultimediaPage : DashboardPage}
      />
      <ContentRoute
        from="/edit-multimedia/:id?"
        component={isAdmin ? EditMultimediaPage : DashboardPage}
      />

      <Redirect to="/error" />
    </Switch>
  );
}
